import React from "react";
import { useIdleTimer } from "react-idle-timer";
import config from "../../config/default.json";
import { useNavigate } from "react-router";

const OrderIdle = () => {
    const navigate = useNavigate();

    const onIdle = () => {
        navigate("/orderIdle");
    }

    useIdleTimer({
        onIdle,
        timeout: config.idleStatus.pages.timeout,
    });

    
    return <></>
}

export default OrderIdle;